import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: ', 'px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  margin-bottom: ', 'px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n']);

import styled from 'styled-components';

import { gridSize, math } from '@atlaskit/theme';

var SkeletonGlobalIconOuter = styled.div(_templateObject, math.divide(gridSize, 2));

SkeletonGlobalIconOuter.displayName = 'SkeletonGlobalIconOuter';
export default SkeletonGlobalIconOuter;